import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-172" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-173" data-mp="o4713081h8ii">
        <SectionHeading id="summary-title" data-id="element-174" data-mp="j7yfb3zc6h2d">Tutto ciò che è <span className="text-energy" data-id="element-175" data-mp="j53v9dk8iy9h">incluso:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-energy/25 bg-navy-card sm:grid-cols-2" data-id="element-176" data-mp="1gtm7fcored83">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-aqua/10 p-4 sm:odd:border-r" data-id="element-177" data-mp="16wrauzc1qmwg">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-energy" data-id="element-178" data-mp="12vftfh3bt7zc">
                <CheckIcon className="h-3.5 w-3.5 text-navy" aria-hidden="true" data-id="element-179" data-mp="3rn8mgqi32ch0" />
              </span>
              <b className="text-sm text-cream" data-id="element-180" data-mp="3nl57vt04arri">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}